<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<dash-gis-flexible-panel [panelTitle]="reportTitle$ | async"
          [width]="panelWidth$ | async"
          [enableResize]="true"
          [enableScroll]="!(shouldDisableScroll$ | async)"
          [disableHistory]="isHistoryEmpty$ | async"
          (panelBack)="historyBack()"
          (resizeEnd)="onResizeEnd($event)"
          (closePanel)="closePanel.emit()">
    <div class="report-box" fxLayout="column" fxFlex>
        <div *ngIf="activeFeatureReports$ | async; let activeReports"
             fxLayout="column" fxFlex>
            <ng-container *ngIf="activeLayers$ | async; let activeLayers">
                <!-- multiple layers -->
                <dash-gis-report-side-tabs *ngIf="activeLayers.length > 1"
                                [featureReports]="activeReports"
                                [uid]="uid"
                                (activeLayer)="setActiveLayer($event)"
                                (recordCount)="setRecordCount($event)"
                                (reportTitle)="setReportTitle($event)"
                                (overrideSubtype)='setSubtype($event)'
                                fxLayout="column" fxFlex></dash-gis-report-side-tabs>

                <div *ngIf="activeLayers.length === 1" fxLayout="column" fxFlex>
                    <!-- multiple reports: single layer or data -->
                    <dash-gis-report-selector *ngIf="activeReports[activeLayers[0]].length > 1"
                                        fxLayout="column" fxFlex="1 1 auto"
                                        class="xyz"
                                        [reportType]="'feature'"
                                        [launchOptions]="activeReports[activeLayers[0]]"
                                        [uid]="uid"
                                        (recordCount)="setRecordCount($event)"
                                        (reportTitle)="setReportTitle($event)"></dash-gis-report-selector>

                    <!-- single layer, single report -->
                    <dash-gis-feature-report *ngIf="activeReports[activeLayers[0]].length === 1"
                                       fxFlex fxLayout="column"
                                       [showControls]="true"
                                       [launchOptions]="activeReports[activeLayers[0]][0]"
                                       [uid]="uid"
                                       (recordCount)="setRecordCount($event)"
                                       (overrideSubtype)="setSubtype($event)"
                                       (reportTitle)="setReportTitle($event)"></dash-gis-feature-report>
                </div>
            </ng-container>
        </div>
    </div>
</dash-gis-flexible-panel>
